import { css, CSSResult } from 'lit'
import { csColorBackground, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'


export const cseSlideIn = {
  backgroundColor: css`var(--cse-slide-in-background-color, ${csColorBackground.primary})`,
  borderRadius: css`var(--cse-slide-in-border-radius, ${csBorder.radiusMinimal})`,
  boxShadow: css`var(--cse-slide-in-box-shadow, ${csShadow.default})`,
  width: css`var(--cse-slide-in-width, 414px)`,
  largeWidth: css`var(--cse-slide-in-large-width, 828px)`,

  headerBackgroundColor: css`var(--cse-slide-in-header-background-color, ${csColorBackground.secondary})`,
  headerTextColor: css`var(--cse-slide-in-header-color, ${csColorText.headings})`,
  headerGap: css`var(--cse-slide-in-header-gap, ${csSpacing.spacing06})`,
  headerPaddingBlock: css`var(--cse-slide-in-header-padding-y, ${csSpacing.spacing06})`,
  headerPaddingInline: css`var(--cse-slide-in-header-padding-x, ${csSpacing.spacing06})`,

  bodyGap: css`var(--cse-slide-in-body-gap, ${csSpacing.spacing06})`,
  bodyPaddingInline: css`var(--cse-slide-in-body-padding-x, ${csSpacing.spacing06})`,
  bodyPaddingBlock: css`var(--cse-slide-in-body-padding-y, ${csSpacing.spacing06})`,

  footerGap: css`var(--cse-slide-in-footer-gap, ${csSpacing.spacing05})`,
}

export const style: CSSResult = css`
  :host {
      display: block;
  }

  :host([hidden]) {
      display: none;
  }

  dialog {
    background-color: ${cseSlideIn.backgroundColor};
    border: none;
    box-shadow: ${cseSlideIn.boxShadow};
    font-size: inherit;
    min-height: 100dvh;
    min-height: 100vh;
    overflow: hidden;
    padding: 0;
    position: fixed;
    text-align: left;
  }

  dialog.placement-right {
    border-top-left-radius: ${cseSlideIn.borderRadius};
    border-bottom-left-radius: ${cseSlideIn.borderRadius};
    margin-right: 0;
    margin-top: 0;
    margin-bottom: 0;
  }

  dialog.placement-left {
    border-top-right-radius: ${cseSlideIn.borderRadius};
    border-bottom-right-radius: ${cseSlideIn.borderRadius};
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 0;
  }

  .size-default {
    width: ${cseSlideIn.width};
  }

  .size-large {
    width: ${cseSlideIn.largeWidth};
  }

  .content {
    height: 100dvh;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .header {
    align-items: center;
    background-color: ${cseSlideIn.headerBackgroundColor};
    display: flex;
    justify-content: space-between;
    gap: ${cseSlideIn.headerGap};
    padding-block: ${cseSlideIn.headerPaddingBlock};
    padding-inline: ${cseSlideIn.headerPaddingInline};

    --cse-text-color: ${cseSlideIn.headerTextColor}
  }

  .header.header--no-content {
    justify-content: flex-end;
  }

  .body {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${cseSlideIn.bodyGap};
    overflow-y: auto;
    padding-block: ${cseSlideIn.bodyPaddingBlock};
    padding-inline: ${cseSlideIn.bodyPaddingInline};
  }

  .footer {
    display: flex;
    gap: ${cseSlideIn.footerGap};
  }

  .footer ::slotted(cse-button) {
    flex: 1;
  }

  dialog::backdrop {
    position: fixed;
    inset: 0;
    background: #00000059; /* NOTE: does not work with CSS variable */
  }

  dialog.no-backdrop::backdrop {
    opacity: 0;
  }

  @media(max-width: ${SCREENS.small}) {
    dialog {
      width: 100vw;
      max-width: 100vw;
      /* Prevent auto margin calculations */
      margin-right: 0;
    }
  }
`
